import { render, staticRenderFns } from "./LeadsCardHeader.vue?vue&type=template&id=6a425194&scoped=true&"
import script from "./LeadsCardHeader.vue?vue&type=script&lang=js&"
export * from "./LeadsCardHeader.vue?vue&type=script&lang=js&"
import style0 from "./LeadsCardHeader.vue?vue&type=style&index=0&id=6a425194&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a425194",
  null
  
)

export default component.exports